import React from "react";
import { BiSmile } from "react-icons/bi";
import {
  BsEmojiFrown,
  BsEmojiSmile,
  BsEmojiNeutral,
  BsEmojiDizzy,
} from "react-icons/bs";
import "./resultsComponents.css";
import { FaRegFaceMehBlank } from "react-icons/fa6";
import * as url from "../../../../utils/url";
import axios from "../../../../axios";

import OoPopover from "../../../../components/UI/Popover/OoPopover";
import { useState } from "react";
import { useEffect } from "react";
import { Modal, ModalBody, ModalHeader, Table } from "reactstrap";
import parse from "react-html-parser";
import { profilePicValidityCheck, Spinner } from "../../../../utils/constants";
import { showYou } from "../../data";
import moment from "moment";

export default function TextSentimentComponentOverall({
  data,
  totalSumOfNumResponses,
  titleAlign = "left",
  totalSentimentCounts,
  isProgress = true,
  currentTrivvy,
  user,
  questionId
}) {
  const getSetimentPercent = (num) => {
    const sumCounts = totalSentimentCounts ? Object.values(totalSentimentCounts).reduce((partialSum, a) => partialSum + a, 0):0

    if(num==0 || sumCounts==0){
      return 0
    }
    return Math.round((num / sumCounts) * 100);
  };

  const [sentimentResponsesModal, setSentimentResponsesModal] = useState({
    open: false,
    title: "",
    data: [],
    loading: false,
  });

  const [questionsMap, setQuestionsMap] = useState();

  const consturctUserObjForExternalUser = (obj) => {
    if (obj.email) {
      return {
        firstName: obj.email,
        identification: "[Email]-",
      };
    } else if (obj.name) {
      const arr = obj.name.split(" ");
      return {
        identification: "[Name]-",
        firstName: arr[0],
        lastName: arr[1] || "",
      };
    } else {
      return {
        identification: "[EmployeeId]-",

        firstName: obj.employeeId,
      };
    }
  };

  useEffect(() => {
    const qIdTextMap = {};

    for (const q of currentTrivvy.questions) {
      qIdTextMap[q.question_id] = q.question_text;
    }
    setQuestionsMap(qIdTextMap);
  }, []);

  const handleGetResponses = (sentiment) => {
    setSentimentResponsesModal({
      open: true,
      title: sentiment,
      data: [],
      loading: true,
    });
    axios
      .post(url.getResponsesForSentiments, {
        triviaId: currentTrivvy._id,
        sentiment: sentiment.toUpperCase(),
      })
      .then(({ data }) => {
        const results = data.data;

        const mainData = [];

        results.map((result) => {
          let textResponses = result.responses.filter(
            (x) =>
              x.question_type == "TEXT" &&
              x.selected_answers &&
              x.selected_answers[0] &&
              x.selected_answers[0].text &&
              x.textSentimentsData &&
              x.textSentimentsData.sentiment == sentiment.toUpperCase()
          );

          if(questionId){
            textResponses = textResponses.filter(x => x.question_id == questionId)
          }

          for (const item of textResponses) {
            mainData.push({
              user: result.userId
                ? result.userId
                : result.userData
                ? consturctUserObjForExternalUser(result.userData)
                : null,

              question: questionsMap[item.question_id],
              date: result.createdOn,
              comment: item.selected_answers[0].text,
              score:
                item.textSentimentsData &&
                item.textSentimentsData[sentiment.toLowerCase()],
            });
          }
        });

        setSentimentResponsesModal({
          open: true,
          title: sentiment,
          data: mainData,
          loading: false,
        });
      });
  };

  const getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "N";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "N";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  if (data) {
    if (isProgress) {
      const segments = [
        {
          name: "Positive",
          percentage: getSetimentPercent(
            totalSentimentCounts && totalSentimentCounts.POSITIVE
            ? totalSentimentCounts.POSITIVE
            : 0,
          ),
          color: "#4CB43C",
          count:
            totalSentimentCounts && totalSentimentCounts.POSITIVE
              ? totalSentimentCounts.POSITIVE
              : "",
        },
        {
          name: "Neutral",
          percentage: getSetimentPercent(totalSentimentCounts && totalSentimentCounts.NEUTRAL
            ? totalSentimentCounts.NEUTRAL
            : 0),
          color: "#FF9900",
          count:
            totalSentimentCounts && totalSentimentCounts.NEUTRAL
              ? totalSentimentCounts.NEUTRAL
              : "",
        },
        {
          name: "Negative",
          percentage: getSetimentPercent(
            totalSentimentCounts && totalSentimentCounts.NEGATIVE
            ? totalSentimentCounts.NEGATIVE
            : 0
          ),
          color: "#F36464",
          count:
            totalSentimentCounts && totalSentimentCounts.NEGATIVE
              ? totalSentimentCounts.NEGATIVE
              : "",
        },
      ];

      return (
        <div>
          {sentimentResponsesModal && sentimentResponsesModal.open && (
            <Modal isOpen={sentimentResponsesModal.open}>
              <ModalHeader
                toggle={() => {
                  setSentimentResponsesModal({
                    open: false,
                    title: "",
                    data: [],
                    loading: false,
                  });
                }}
                className={`sentiment_response_modal_bg ${sentimentResponsesModal.title}`}
              >
                {sentimentResponsesModal.title} Sentiment Responses
              </ModalHeader>
              <ModalBody>
                {sentimentResponsesModal.loading ? (
                  <div className="text-center">
                    Retrieving comments{" "}
                    <img src={Spinner} height="30px" width="30px" />
                  </div>
                ) : (
                  <Table className="sentiments_users_response_table">
                    <thead>
                      <tr>
                        <th>Question</th>
                        <th>User</th>
                        <th>Date</th>
                        <th>Comment</th>
                        <th>% {sentimentResponsesModal.title}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {sentimentResponsesModal.data.map((result) => {
                        return (
                          <tr>
                            <td>{parse(result.question)}</td>
                            <td>
                              {result.user && !result.isAnonymous ? (
                                <span
                                  className="trivia_table_text_wrapper"
                                  onClick={(e) => {
                                    e.stopPropagation();

                                    // if(result.user._id){
                                    //   props.history.push(`/home/${user.profile.organizationId._id}/profile/${result.user._id}`)
                                    // }
                                  }}
                                >
                                  {profilePicValidityCheck(
                                    result.user.profilePic
                                  ) ? (
                                    <img
                                      src={result.user.profilePic}
                                      height="35px"
                                      width="35px"
                                      style={{ borderRadius: "50%" }}
                                    />
                                  ) : (
                                    <span
                                      className="spotlightUserInitials"
                                      data-letters={getInitials(result.user)}
                                    ></span>
                                  )}{" "}
                                  {result.user.identification}{" "}
                                  {result.user.firstName} {result.user.lastName}
                                </span>
                              ) : (
                                <span className="trivia_table_text_wrapper">
                                  <span
                                    className="spotlightUserInitials"
                                    data-letters={"AU"}
                                  ></span>
                                  Anonymous user{" "}
                                  {showYou(user.profile, result) ? "(You)" : ""}
                                </span>
                              )}
                            </td>
                            <td>
                              {moment(result.createdOn).format("MMM DD, YYYY")}
                            </td>
                            <td>{result.comment}</td>
                            <td>{Math.round((result.score / 1) * 100)}%</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                )}
              </ModalBody>
            </Modal>
          )}
          <div className="multicolor-progress-bar mt-3">
            {segments.map((segment, index) => (
              <div
                key={index}
                className="multicolor-progress-segment cursor-pointer"
                style={{
                  width: `${segment.percentage}%`,
                  backgroundColor: segment.color,
                }}
                title={`${segment.percentage}%`}
                onClick={() => {
                  handleGetResponses(segment.name);
                }}
              ></div>
            ))}
          </div>
          <div className="mt-2 d-flex justify-content-between trivvy-res-insights-sent-scores">
            {segments.map((x, i) => {
              return (
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    handleGetResponses(x.name);
                  }}
                >
                  {x.count} {x.name}{" "}
                  <span
                    style={{
                      fontWeight: "bold",
                      color: x.color,
                    }}
                  >
                    {x.percentage}%
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      );
    } else {
      return (
        <div
          style={{ textAlign: titleAlign }}
          className="sentiment-analysis-info-popup-container"
        >
          <div className="d-flex mt-3">
            <div className="ml-0 sentiment-analysis sentiment-analysis_positive">
              <BsEmojiSmile />{" "}
              {getSetimentPercent(data["avgPositive"] || data["positive"])}%
            </div>
            <div className="sentiment-analysis sentiment-analysis_neutral">
              <BsEmojiNeutral />{" "}
              {getSetimentPercent(data["avgNeutral"] || data["neutral"])}%
            </div>
            <div className="sentiment-analysis sentiment-analysis_negative">
              <BsEmojiFrown />{" "}
              {getSetimentPercent(data["avgNegative"] || data["negative"])}%
            </div>
            {/* <div className="sentiment-analysis sentiment-analysis_mixed">
              <FaRegFaceMehBlank /> {getSetimentPercent(data["avgMixed"])}%
            </div> */}
          </div>
        </div>
      );
    }
  } else {
    return (
      <div style={{ textAlign: titleAlign }}>
        <div className="multicolor-progress-bar mt-3">
          <div
            className="multicolor-progress-segment cursor-pointer"
            style={{
              width: `100%`,
              backgroundColor: "#ccc8c8",
            }}
            title={`No sentiment analysis yet`}
          ></div>
        </div>
        <div className="mt-2 text-center">No Sentiments</div>
      </div>
    );
  }
}
